import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu--companies-index--company-card--component', class extends Controller {
  static targets = ['tags', 'toggle', 'toggleText']
  static values = { clientId: Number, areaName: String }

  connect() {
    // CSSが適用されてから高さを計算するため少し遅延
    requestAnimationFrame(() => {
      this.checkOverflow()
    })
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  disconnect() {
    window.removeEventListener('resize', this.handleResize.bind(this))
  }

  handleResize() {
    this.checkOverflow()
  }

  // SP用タグのオーバーフローチェック
  checkOverflow() {
    if (!this.hasTagsTarget || !this.hasToggleTarget) return

    const tags = this.tagsTarget
    const toggle = this.toggleTarget

    // 展開中は非表示にしない
    if (tags.classList.contains('is-expanded')) {
      toggle.style.display = 'flex'
      return
    }

    // 一時的にmax-heightを解除して実際の高さを取得
    const originalMaxHeight = tags.style.maxHeight
    const originalOverflow = tags.style.overflow
    tags.style.maxHeight = 'none'
    tags.style.overflow = 'visible'

    const fullHeight = tags.scrollHeight

    // 元に戻す
    tags.style.maxHeight = originalMaxHeight
    tags.style.overflow = originalOverflow

    // CSSのmax-height: 64pxと同じ値を超える場合のみボタンを表示
    const maxVisibleHeight = 68
    if (fullHeight > maxVisibleHeight) {
      toggle.style.display = 'flex'
    } else {
      toggle.style.display = 'none'
    }
  }

  // SP用タグのトグル
  toggle() {
    const tags = this.tagsTarget
    const toggle = this.toggleTarget
    const toggleText = this.toggleTextTarget
    const isExpanded = tags.classList.contains('is-expanded')

    if (isExpanded) {
      tags.classList.remove('is-expanded')
      toggle.classList.remove('is-expanded')
      toggleText.textContent = 'もっと見る'
      // 閉じた後に再度チェック
      this.checkOverflow()
    } else {
      tags.classList.add('is-expanded')
      toggle.classList.add('is-expanded')
      toggleText.textContent = '閉じる'
    }
  }

  // 「すべての画像を見る」ボタンのGA4イベント計測
  trackSeeAllImages() {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'see_all_images_click',
      client_id: this.clientIdValue,
      area_name: this.areaNameValue,
      page_url: window.location.href
    })
  }
})
